/**
 * @fileoverview Songs Tab Section component.
 * @summary Displays songs tab with song list.
 *
 * @package KaraoNow
 * @module apps/front/src/pages/singer/components/SongsTabSection
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { useTranslation } from 'react-i18next'
import { SingerSongCard } from './SingerSongCard.js'

interface SingerSong {
  id: string
  title: string
  artist: string
  eventName: string
  organizerName: string
  addedAt: string
  eventDate?: string
}

interface SongsTabSectionProps {
  songs: SingerSong[]
  formatDate: (dateString: string) => string
}

/**
 * @summary Songs tab section component.
 * @param {SongsTabSectionProps} props - Component props.
 * @returns {React.ReactElement} Songs tab section.
 */
export function SongsTabSection({
  songs,
  formatDate,
}: SongsTabSectionProps) {
  const { t } = useTranslation()

  return (
    <div>
      {songs.length === 0 ? (
        <div className="card bg-base-100 dark:bg-base-800 text-center py-12">
          <p className="text-base-600 dark:text-base-400">{t('singer.noSongs')}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {songs.map((song) => (
            <SingerSongCard
              key={`${song.id}-${song.eventName}`}
              song={song}
              formatDate={formatDate}
            />
          ))}
        </div>
      )}
    </div>
  )
}

